export const GAS_TYPE: any = {
  CO2: 'CO₂',
  CH4: 'CH₄',
  N2O: 'N₂O',
  HFCs: 'HFCs',
  PFCs: 'PFCs',
  SF6: 'SF₆',
  NF3: 'NF₃',
}
